import OtpComponent from "../components/OtpComponent";

import useOtp from "../hook/useOtp";


const OtpPage = ({

}) => {
    const otp = useOtp();
    return <OtpComponent {...otp} />
}
export default OtpPage;